import map from 'lodash/map'
import React from 'react'
import { AvatarGroup } from '@ztechapps/webui.util'
import { EmptyMembers } from './EmptyMembers'
import type { InlineInputContentOptions, InlineInputProps } from '../InlineInput'
import { InlineInput } from '../InlineInput'
import { MembersSelect } from './MembersSelect'

export const MembersInlineInputDisplayContent = ({ value }) => {
  const dataArray = map(value, (e) => {
    let picture = e?.profile.picture ?? ''
    if (picture.includes('/dft-customer.jpg')) {
      picture = null
    }

    return { ...e.profile, src: picture }
  })

  return <AvatarGroup dataArray={dataArray} />
}

export const MembersInlineInputEmptyContent = () => {
  return <EmptyMembers />
}
export const MembersInlineInputEditContent = ({ setNewValue, ...rest }) => {
  return <MembersSelect autoFocus {...rest} onChange={(e) => setNewValue(e)} />
}

export const MembersInlineInput = ({
  name = 'members',
  canEdit,
  displayContent,
  emptyContent,
  editContent,
  updateParams,
  parentInputComponent,
  inputProps,
  initialValues,
  ...rest
}: InlineInputProps) => {
  const ParentInput = parentInputComponent ?? InlineInput

  //remap it to include the lable and value
  // initialValues = {
  //   ...initialValues,
  //   [name]: {
  //     label: initialValues?.label,
  //     value: initialValues?.value,
  //   },
  // }

  displayContent = displayContent ?? ((value) => <MembersInlineInputDisplayContent value={value} />)

  emptyContent = emptyContent ?? (() => <MembersInlineInputEmptyContent />)
  editContent =
    editContent ??
    (({ setNewValue, ...rest }: InlineInputContentOptions) => {
      return <MembersInlineInputEditContent {...{ ...rest, ...inputProps, setNewValue }} />
    })

  updateParams =
    updateParams ??
    (({ _id, updatedValue }) => {
      const members = map(updatedValue, (e) => e._id)

      return {
        input: {
          _id,
          members,
        },
      }
    })

  return (
    <ParentInput
      {...{
        canEdit,
        name,
        ...rest,
        updateParams,
        displayContent,
        emptyContent,
        editContent,
        initialValues,
      }}
    />
  )
}
